import React from "react";
import MobilePopup from '../shared/MobilePopup/MobilePopup';
import Cookies from 'js-cookie';
import { PuzzleNames } from '../../../utils/types';
import { DOMAIN } from '../shared/utils';
import { TruthsortingStore } from './TruthsortingStore';
import { isMobile } from 'react-device-detect';

const MobileTruthsortingInstructions = () => {
  const isOpen = TruthsortingStore.useState(s => s.instructionsAreOpen);

  const onClose = () => {
    Cookies.set(`${PuzzleNames.Truthsorting}InstructionsDismissed`, 'true', {
      domain: DOMAIN,
      expires: 365,
    });
    TruthsortingStore.update(s => {
      s.instructionsAreOpen = false;
      s.isSoftPaused = false;
    });
  };

  return (
    <MobilePopup isOpen={isOpen} onClose={onClose} title="How to Play Truthsorting">
      <p>
        Truth slots are white. Lie slots are black.
      </p>
      <br/>
      <p>
        {isMobile ? 'Drag' : 'Click and drag'} to reorder the statements so that truth slots contain truths and lie slots contain lies.
      </p>
      <br/>
      <p>
        Whether statements are truths or lies depends entirely on the order they're in.
      </p>
      <br/>
      <p>
        A checkmark is shown on any statement whose current truthfulness matches its slot, but that doesn't necessarily mean it's in the right place. The puzzle is solved when <span className="boldText">all</span> statements have checkmarks.
      </p>
      <br/>
      <p>
        There is only one solution. Good luck.
      </p>
    </MobilePopup>
  );
};

export default MobileTruthsortingInstructions;
